import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bars3Icon, DocumentCheckIcon, XMarkIcon } from '@heroicons/react/24/outline';

const SECTION_LINKS = [
  { hash: '#how-it-works', label: 'How it works' },
  { hash: '#features', label: 'Features' },
  { hash: '#pricing', label: 'Pricing' },
  { hash: '#faq', label: 'FAQ' },
];

export default function V2Nav() {
  const location = useLocation();
  const onHome = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);
  const sectionHref = (hash) => (onHome ? hash : `/${hash}`);

  return (
    <header className={`hpv2-nav${scrolled ? ' is-scrolled' : ''}`}>
      <div className="hpv2-container hpv2-nav-inner">
        {onHome ? (
          <a href="#top" className="hpv2-brand" onClick={closeMenu}>
            <span className="hpv2-brand-mark" aria-hidden="true">
              <DocumentCheckIcon className="h-5 w-5" strokeWidth={2} />
            </span>
            <span className="hpv2-brand-name">SmileConsent</span>
          </a>
        ) : (
          <Link to="/" className="hpv2-brand" onClick={closeMenu}>
            <span className="hpv2-brand-mark" aria-hidden="true">
              <DocumentCheckIcon className="h-5 w-5" strokeWidth={2} />
            </span>
            <span className="hpv2-brand-name">SmileConsent</span>
          </Link>
        )}

        <nav className="hpv2-nav-links" aria-label="Page sections">
          {SECTION_LINKS.map((link) => (
            <a key={link.hash} href={sectionHref(link.hash)}>
              {link.label}
            </a>
          ))}
          <Link to="/book-demo">Book a demo</Link>
        </nav>

        <div className="hpv2-nav-actions">
          <Link to="/login" className="hpv2-btn hpv2-btn--ghost">
            Sign in
          </Link>
          <Link to="/register" className="hpv2-btn hpv2-btn--primary">
            Start free trial
          </Link>
        </div>

        <button
          type="button"
          className="hpv2-nav-toggle"
          aria-expanded={menuOpen}
          aria-controls="hpv2-mobile-menu"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <XMarkIcon className="h-5 w-5" /> : <Bars3Icon className="h-5 w-5" />}
        </button>
      </div>

      <div
        id="hpv2-mobile-menu"
        className={`hpv2-mobile-menu${menuOpen ? ' is-open' : ''}`}
      >
        <div className="hpv2-container">
          {SECTION_LINKS.map((link) => (
            <a key={link.hash} href={sectionHref(link.hash)} onClick={closeMenu}>
              {link.label}
            </a>
          ))}
          <Link to="/book-demo" onClick={closeMenu}>
            Book a demo
          </Link>
          <Link to="/login" onClick={closeMenu}>
            Sign in
          </Link>
          <Link to="/register" className="hpv2-btn hpv2-btn--primary" style={{ marginTop: '0.75rem' }} onClick={closeMenu}>
            Start free trial
          </Link>
        </div>
      </div>
    </header>
  );
}
